module.exports = __webpack_public_path__ + "img/05_Bronze_Award.8ca97fd5.png";